export default __webpack_public_path__ + "static/media/like.78eb7339.svg";